import React, { useEffect, useState } from "react";
import "../CSS/Currentopening.css";
import Footer from "../../Footer/Footer";
import Footer1 from "../../Footer1/Footer1";
import Navbar from "../../Navbar/Navbar";
import Footerlast from "../../Footerlast/Footerlast";
import { Link, useNavigate } from "react-router-dom";
import Backend_url from "../../../Important/BackEnd";
import Token from "../../../Important/TOKEN";
import axios from "axios";
import SendEnquiry from "./SendEnquiry";
import { Icon } from "@iconify/react/dist/iconify.js";

function Currenopening() {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [expandedJobId, setExpandedJobId] = useState(null);
  const [applyClickedJobId, setApplyClickedJobId] = useState(null);
  const [jsonlist, setjsonlist] = useState([]);
  const [openModal, setopentModal] = useState(false);
  const navigate = useNavigate();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = jsonlist.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(jsonlist.length / itemsPerPage);

  const handleJobClick = (uniqueId) => {
    setExpandedJobId(expandedJobId === uniqueId ? null : uniqueId);
    setApplyClickedJobId(null);
  };

  const handleApplyClick = (uniqueId) => {
    if (applyClickedJobId === uniqueId) {
      setopentModal(true);
    } else {
      setExpandedJobId(uniqueId);
      setApplyClickedJobId(uniqueId);
    }
  };

  const fetchjson = async () => {
    try {
      const res = await axios.get(`${Backend_url}/jsonroute/get`, {
        headers: { Authorization: "Bearer " + Token },
      });
      res.data.json.forEach((jsondata) => {
        const parsedObject = JSON.parse(jsondata.JsonObject);
        if (parsedObject.name === "currentop") {
          const reverse = [...parsedObject.data].reverse();
          setjsonlist(reverse);
          fetchfromcurrentop();
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchfromcurrentop = async () => {
    try {
      const res = await axios.get(`${Backend_url}/currentop/all/cop`, {
        headers: { Authorization: "Bearer " + Token },
      });
      const alldata = [...res.data.data].reverse();
      setjsonlist((prev) => [...alldata, ...prev]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchjson();
  }, []);

  return (
    <>
      <Footer />
      <Navbar />
      <div className="current sm:!flex-row sm:!py-[5px] sm:gap-[4px]">
        <div className="current-job1 sm:flex sm:items-center sm:justify-center">
          <h1 className="sm:!text-[16px]">CURRENT OPENINGS</h1>
        </div>
        <div className="current-job2">
          <ul className="sm:!m-0 sm:!right-0 sm:!w-auto">
            <li className="sm:!p-0">
              <Link to="/">Home</Link>
            </li>
            <li className="sm:!p-0">/</li>
            <li className="sm:!p-0">Current job</li>
          </ul>
        </div>
      </div>

      <div className="current-opening">
        <div className="current-opening1">
          {currentItems.map((item, index) => {
            // Generate a unique id for the current page’s item
            const uniqueId = `${currentPage}-${index}`;

            return (
              <div className="data-container" key={uniqueId}>
                <div className="heading">
                  <div className="h1">
                    <h1
                      className="text-[#389ADC]"
                      onClick={() => handleJobClick(uniqueId)}
                    >
                      <span className="text-xl">&#8226;</span> {item.Heading}
                    </h1>
                  </div>
                  <div className="button">
                    <button
                      className="btn"
                      onClick={() => handleApplyClick(uniqueId)}
                    >
                      {expandedJobId === uniqueId &&
                        applyClickedJobId === uniqueId
                        ? "Send Enquiry"
                        : "Apply now"}
                    </button>
                  </div>
                </div>

                {expandedJobId === uniqueId ? (
                  <div className="job-detail-dropdown">
                    <ul>
                      <li className="for-mobile-gap">
                        <strong style={{ display: "flex" }}>
                          <i class="fa-solid fa-location-dot"></i> Location :
                        </strong>{" "}
                        {item.location}
                      </li>
                      <li className="for-mobile-gap">
                        <strong>
                          <i class="fa-solid fa-briefcase"></i> Experience :
                        </strong>{" "}
                        {item.Expreriance}
                      </li>
                      <li className="for-mobile-gap">
                        <strong style={{ display: "flex" }}>
                          <Icon
                            icon="icon-park-solid:people"
                            width="18"
                            height="18"
                          />
                          Post :
                        </strong>{" "}
                        {item.post}
                      </li>
                      <li className="for-mobile-gap">
                        <strong style={{ display: "flex" }}>
                          <Icon
                            icon="tdesign:money-filled"
                            width="18"
                            height="18"
                          />
                          Salary :
                        </strong>{" "}
                        {item.Salary}
                      </li>
                      <li className="for-mobile-gap">
                        <strong style={{ display: "flex" }}>
                          <Icon
                            icon="stash:data-date-solid"
                            width="18"
                            height="18"
                          />
                          Date :
                        </strong>{" "}
                        {item.Date}
                      </li>
                    </ul>
                    {/* <div className="key-container">
                      <div className="tag">Key Skills :</div>
                      <div className="data-content">
                        <p>{item.key}</p>
                      </div>
                    </div>
                    <div className="description-container">
                      <div className="tag">Description:</div>
                      <div className="data-content">
                        <p>{item.Description}</p>
                      </div>
                    </div> */}
                    <div className="key-container">
                      <div className="tag">Key Skills :</div>
                      <div className="data-content">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.key || "",
                          }}
                        />
                      </div>
                    </div>

                    <div className="description-container">
                      <div className="tag">Description:</div>
                      <div className="data-content">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.Description || "",
                          }}
                        />
                      </div>
                    </div>

                  </div>
                ) : (
                  <ul>
                    <li>
                      <span> Number of Post :</span> {item.post}
                    </li>
                    <li>
                      <span>Salary :</span> {item.Salary}
                    </li>
                    <li>
                      <span> Last Date :</span> {item.Date}
                    </li>
                  </ul>
                )}
              </div>
            );
          })}

          <div className="button1">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                className={`btn1 ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      </div>

      {openModal && (
        <SendEnquiry openModal={openModal} setopentModal={setopentModal} />
      )}
      <Footer1 />
      <Footerlast />
    </>
  );
}

export default Currenopening;
